import React from 'react';

export default ({ label, disabled, onClick, isLoading }) => (
	<button
		className="booking-btn"
		//className={isLoading ?  "btn btn-function btn-loading btn-lg margin-top" : "btn btn-function btn-lg margin-top"}
		disabled={disabled || isLoading}
		onClick={onClick}>
		{label}
	</button>
)